import { IdParams } from '../dto/common.js';
import { DocIdParams, PutBodyResponseV1 } from '../dto/documents.js';
import { listOf } from '../dto/list.js';
import { ApplyTemplateRequestV1, TemplateCreateRequestV1, TemplatesQueryV1, TemplateUpdateRequestV1, TemplateV1, } from '../dto/templates.js';
import { defineRoute } from '../route/define-route.js';
import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_TEMPLATE, EXAMPLE_TEMPLATE_CREATED } from './examples-workspace.js';
/**
 * Templates (1.0b deliverable 17), built by 1.S: the template chips of a new page, and the Deity
 * type's own templates. A template names a type, not a document, so its routes are `none`;
 * instantiating one into a document is a body write (`deny`).
 */
const owned = { owner: '1.S', since: 'exit-1a', status: 'frozen', auth: 'session' };
/**
 * A template write the rows refuse (1.S's `TemplateInvalid`: an unknown, reference or archived
 * type, a body `checkBody` refuses, props the type refuses, links, a taken name) answers 422
 * `invalid_body`; a body of another schema version 422 `unsupported_schema_version` (CS r2c, 1.S
 * deliverable 9 item 1).
 */
const templateWrite = { 422: ['invalid_body', 'unsupported_schema_version'] };
const custom = EXAMPLE_IDS.templateDeityCustom.id;
/** One type's templates, or every template (a bounded list). */
export const templatesList = defineRoute({
    id: 'templates.list',
    method: 'GET',
    path: '/api/templates',
    query: TemplatesQueryV1,
    response: { kind: 'json', schema: listOf(TemplateV1) },
    reference: 'none',
    ...owned,
    examples: {
        request: { query: { typeId: EXAMPLE_IDS.typeDeity.id } },
        response: { items: [EXAMPLE_TEMPLATE], next: null },
    },
});
export const templatesCreate = defineRoute({
    id: 'templates.create',
    method: 'POST',
    path: '/api/templates',
    body: TemplateCreateRequestV1,
    response: { kind: 'json', schema: TemplateV1, status: 201 },
    errors: templateWrite,
    reference: 'none',
    ...owned,
    examples: {
        request: {
            body: {
                docTypeId: EXAMPLE_IDS.typeDeity.id,
                name: 'Minor deity',
                variant: 'quick',
                body: { type: 'doc', content: [{ type: 'paragraph' }] },
            },
        },
        response: EXAMPLE_TEMPLATE_CREATED,
    },
});
export const templatesUpdate = defineRoute({
    id: 'templates.update',
    method: 'PATCH',
    path: '/api/templates/:id',
    params: IdParams,
    body: TemplateUpdateRequestV1,
    response: { kind: 'json', schema: TemplateV1 },
    errors: templateWrite,
    reference: 'none',
    ...owned,
    examples: {
        request: { params: { id: custom }, body: { name: 'Deity' } },
        response: EXAMPLE_TEMPLATE,
    },
});
/** Archive a template. Its success archives the template `docs.applyTemplate`'s example uses. */
export const templatesArchive = defineRoute({
    id: 'templates.archive',
    method: 'POST',
    path: '/api/templates/:id/archive',
    params: IdParams,
    response: { kind: 'json', schema: TemplateV1 },
    reference: 'none',
    ...owned,
    examples: {
        request: { params: { id: custom } },
        response: { ...EXAMPLE_TEMPLATE, archived: true },
        consumes: true,
    },
});
/**
 * Instantiate a template into a document's body, re-minting every id it brings; a page with text
 * keeps it and the template's blocks follow. A stale `baseBodyVersion` answers 409
 * `version_conflict` with `VersionConflictDetailsV1`, a trashed page 409 `document_trashed`, a body
 * the save refuses 422 `invalid_body` (CS r2c, 1.S deliverable 9 item 1), and a template of another
 * type 422 `template_type_mismatch`.
 */
export const docsApplyTemplate = defineRoute({
    id: 'docs.applyTemplate',
    method: 'POST',
    path: '/api/docs/:id/apply-template',
    params: DocIdParams,
    body: ApplyTemplateRequestV1,
    response: { kind: 'json', schema: PutBodyResponseV1 },
    errors: {
        409: ['version_conflict', 'document_trashed'],
        422: ['invalid_body', 'template_type_mismatch'],
    },
    reference: 'deny',
    docIds: { owner: ['params.id'] },
    ...owned,
    examples: {
        request: {
            params: { id: EXAMPLE_IDS.deityDrownedQueen.id },
            body: { templateId: custom, baseBodyVersion: 1 },
        },
        response: { bodyVersion: 2, clientSeq: 0, patches: [], warnings: [] },
        consumes: true,
    },
});
//# sourceMappingURL=templates.js.map